module.exports = __webpack_public_path__ + "img/CW.98e781af.png";